export default "/_next/static/chunks/fonts/Source Sans Pro It-fb96197d794f3be752879aec13b05d40.otf";